import {
  IEventCollectionData,
  IEventCollectionDataActiveEvents,
  IEventCollectionDataActiveTypeticketcollections,
  IEventCollectionMetadata,
} from 'meta/pages/v4/eventCollection'
import { useAppSelector } from 'store'
import { CollectionSelectors } from 'store/pages/collection'

export const useCollectionDetails = ({
  id,
  language,
}: {
  id: string
  language: string
}): IEventCollectionData | undefined => useAppSelector(CollectionSelectors.getCollectionDetails({ id, language }))

export const useCollectionActiveEvents = ({
  id,
  language,
}: {
  id: string
  language: string
}):
  | {
      data: Record<number, IEventCollectionDataActiveEvents>
      metadata: IEventCollectionMetadata
    }
  | undefined => useAppSelector(CollectionSelectors.getCollectionActiveEvents({ id, language }))

export const useCollectionActiveTypeticketcollections = ({
  id,
  language,
}: {
  id: string
  language: string
}):
  | {
      data: Record<number, IEventCollectionDataActiveTypeticketcollections>
      metadata: IEventCollectionMetadata
    }
  | undefined => useAppSelector(CollectionSelectors.getCollectionActiveTypeticketcollections({ id, language }))

export const useCollectionEvents = ({
  id,
  language,
}: {
  id: string
  language: string
}):
  | {
      data: Record<number, IEventCollectionDataActiveEvents>
      metadata: IEventCollectionMetadata
    }
  | undefined => useAppSelector(CollectionSelectors.getCollectionEvents({ id, language }))
